/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const forgotPasswordInputDataSchema = z.object({
	email: z.string(),
})

export type ForgotPasswordInputDataSchema = z.infer<typeof forgotPasswordInputDataSchema>
